"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsFileTooLargeForResizing = getIsFileTooLargeForResizing;
exports.resize = resize;

var _Url = _interopRequireDefault(require("urlinator/Url"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _file = require("./file");

var _fileSizes = require("../constants/fileSizes");

var _cdnHostnames = require("./cdnHostnames");

function filterParams(params) {
  var filteredParams = {};
  var validKeys = ['width', 'height', 'upscale', 'upsize', 'length', 'quality'];
  validKeys.forEach(function (key) {
    if (params[key]) {
      filteredParams[key] = params[key];
    }
  });
  return filteredParams;
}

function getIsFileTooLargeForResizing(file) {
  return file.get('size') >= _fileSizes.BYTES_IN_MEGABYTE * 5;
}

var DEFAULT_RESIZE_OPTIONS = {
  convertCustomDomainToCdn: false
};
/**
 * Transforms FM urls to structure needed to route to image resizing service
 * and appends resize query params
 *
 * @param {string} url
 * @param {object} params
 * @param {object} options
 */

function resize(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var parsed = new _Url.default(url);
  var pathSegments = parsed.pathname.split('/');
  var hubfsSegment = pathSegments.indexOf('hubfs');
  options = Object.assign({}, DEFAULT_RESIZE_OPTIONS, {}, options); // url is not a file manager url, so return

  if (hubfsSegment < 0) {
    return url;
  }

  var updatedParams = Object.assign({}, parsed.params, {}, filterParams(params));

  if ((0, _file.isCdn)(parsed.hostname) && pathSegments.indexOf('hub') < 0) {
    var pathSuffix = pathSegments.slice(3).join('/');
    var hubId = parseInt(pathSegments[hubfsSegment + 1], 10);

    if (!hubId) {
      return url;
    }

    parsed.update({
      pathname: "/hub/" + hubId + "/hubfs/" + pathSuffix,
      params: updatedParams
    });
  } else if (pathSegments[1] === 'hubfs') {
    var _pathSuffix = pathSegments.slice(2).join('/');

    parsed.update({
      pathname: "/hs-fs/hubfs/" + _pathSuffix,
      params: updatedParams
    });

    if (options.convertCustomDomainToCdn) {
      parsed.update({
        pathname: "/hub/" + _PortalIdParser.default.get() + "/hubfs/" + _pathSuffix,
        hostname: (0, _cdnHostnames.getCdnHostnameForPortal)()
      });
    }
  } else {
    parsed.update({
      params: updatedParams
    });
  }

  return parsed.href;
}